export default "__VITE_ASSET__Cpreo0Pp__"